import { render, staticRenderFns } from "./trainingModulePageFreeAnswer.vue?vue&type=template&id=08e65c74&scoped=true&"
import script from "./trainingModulePageFreeAnswer.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageFreeAnswer.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageFreeAnswer.vue?vue&type=style&index=0&id=08e65c74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e65c74",
  null
  
)

export default component.exports